import {
	INDICATORS_PROGRESS_LOADING_TRUE,
	INDICATORS_PROGRESS_GET,
	INDICATORS_PROGRESS_ERROR,
	INDICATORS_RESULTS_LOADING_TRUE,
	INDICATORS_RESULTS_GET,
	INDICATORS_RESULTS_ERROR,
	PAYLOAD_INSIGHTS_LOADING_TRUE,
	PAYLOAD_INSIGHTS_GET,
	PAYLOAD_INSIGHTS_ERROR
} from '../actions/types';

const initialState = {
	indicators_progress_loading: true,
	indicators_progress: {},
	indicators_results_loading: true,
	indicators_results: {},
	payload_insights_loading: true,
	payload_insights: {},
	indicators_errors: {}
}

export default function indicatorsReducer(state = initialState, action) {
	switch(action.type) {
		case INDICATORS_PROGRESS_LOADING_TRUE:
			return {
				...state,
				indicators_progress_loading: true
			}
		case INDICATORS_PROGRESS_GET:
			delete state.indicators_errors.indicators_progress
			return {
				...state,
				indicators_progress_loading: false,
				indicators_progress: action.payload
			}
		case INDICATORS_PROGRESS_ERROR:
			return {
				...state,
				indicators_progress_loading: false,
				indicators_errors: {
					...state.indicators_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		case INDICATORS_RESULTS_LOADING_TRUE:
			return {
				...state,
				indicators_results_loading: true
			}
		case INDICATORS_RESULTS_GET: {
			const { indicators_results, ...rest } = state.indicators_errors;
			return {
				...state,
				indicators_errors: rest,
				indicators_results_loading: false,
				indicators_results: action.payload
			}
		}
		case INDICATORS_RESULTS_ERROR:
			return {
				...state,
				indicators_results_loading: false,
				indicators_errors: {
					...state.indicators_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		case PAYLOAD_INSIGHTS_LOADING_TRUE:
			return {
				...state,
				payload_insights_loading: true
			}
		case PAYLOAD_INSIGHTS_GET: {
			const { payload_insights, ...rest } = state.indicators_errors;
			return {
				...state,
				indicators_errors: rest,
				payload_insights_loading: false,
				payload_insights: action.payload
			}
		}
		case PAYLOAD_INSIGHTS_ERROR:
			return {
				...state,
				payload_insights_loading: false,
				indicators_errors: {
					...state.indicators_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
